import React from 'react'

import messages from '../../i18n'
import { intl, IntlInterface } from '../../hoc'
import { Notification } from '../../components/'
import { NotificationSeverityEnum } from '../../redux/reducers/notification/model'

interface Props extends IntlInterface {
  cacheSmsStatus: boolean
  phoneNumber: string
}

export const CacheSmsNotification: React.FC<Props> = (props: Props) => {
  const { cacheSmsStatus, phoneNumber, translate } = props

  const alertText = cacheSmsStatus
    ? translate(messages.SaveAndReturn.newSmsCodeSent, { phoneNumber })
    : translate(messages.SaveAndReturn.smsCodeSent, { phoneNumber })

  return (
    <Notification description={alertText} severity={NotificationSeverityEnum.Normal} type="info" />
  )
}

export default intl(CacheSmsNotification)
